/**
 * Thống kê thiết bị bảng điện tử theo địa bàn — cùng bố cục và cách tính với "Danh sách đài truyền
 * thanh" của cụm loa (MH-33): `GET /api/v1/statistics/stations?loaiThietBi=bang_tin_dien_tu`. Số kết nối
 * theo gói DV016 còn hạn, "đài ứng dụng CNTT" = xã có bảng đã báo DV016, bản tin đã phát = nhật ký DV013.
 */
import type { ReactNode } from 'react';
import { viLichNhatKy } from '../ngon-ngu/vi-lich-nhat-ky';
import type { thietBiApi } from '../api/thiet-bi-api';
import { BangDaiTruyenThanh } from './MH33ThongKe';
import './lich-nhat-ky.css';

const t = viLichNhatKy.thongKe;

export function ThongKeBangDienTu({ api }: { api?: Pick<typeof thietBiApi, 'danhSachDai'> } = {}): ReactNode {
  return (
    <div className="man-hinh man-hinh--thong-ke" data-man-hinh="thong-ke-bang-dien-tu">
      <header className="man-hinh__dau">
        <h1>{t.tieuDeBang}</h1>
      </header>
      <BangDaiTruyenThanh
        loaiThietBi="bang_tin_dien_tu"
        nhan={t.tieuDeBang}
        tenTep={t.tenTepBang}
        api={api}
      />
    </div>
  );
}
